var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import TagManager from 'react-gtm-module';
import ECommerceEventType from '../enums/analytics-ecommerce-event-type';
import { ThemisAnalyticsError } from '../errors';
const emptyECommerce = {
    ecommerce: null,
};
export default class GTMService {
    constructor(options) {
        var _a;
        this.defaultOptions = options;
        this.gtmConfig = ((_a = options === null || options === void 0 ? void 0 : options.config) === null || _a === void 0 ? void 0 : _a.gtmService)
            ? options.config.gtmService
            : null;
    }
    initialize(analyticsOptions) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const config = ((_a = analyticsOptions === null || analyticsOptions === void 0 ? void 0 : analyticsOptions.config) === null || _a === void 0 ? void 0 : _a.gtmService)
                ? analyticsOptions.config.gtmService
                : this.gtmConfig;
            if (config == null) {
                throw new ThemisAnalyticsError('Unable to get configuration for GTM');
            }
            try {
                TagManager.initialize(config);
            }
            catch (error) {
                throw new ThemisAnalyticsError('Unable to initialize for GTM' + error);
            }
            return true;
        });
    }
    triggerEvent(eventName) {
        const pushEvent = { event: eventName };
        this.__push(pushEvent);
    }
    triggerCustomEvent(eventName, variables) {
        const baseEventData = { event: eventName };
        const pushEvent = variables
            ? Object.assign(baseEventData, variables)
            : baseEventData;
        window.dataLayer.push(pushEvent);
    }
    triggerECommerceEvent(eventType, event) {
        if (this.__hasItems(event)) {
            const pushEvent = {
                ecommerce: null,
                event: eventType,
            };
            switch (eventType) {
                case ECommerceEventType.AddPaymentInfo:
                case ECommerceEventType.AddShippingInfo:
                case ECommerceEventType.AddToWishList:
                case ECommerceEventType.AddToCart:
                case ECommerceEventType.BeginCheckout:
                case ECommerceEventType.Purchase:
                case ECommerceEventType.Refund:
                case ECommerceEventType.RemoveFromCart:
                case ECommerceEventType.ViewCart:
                    pushEvent.ecommerce = this.__cleanMultiItemEvent(event);
                    break;
                case ECommerceEventType.SelectItem:
                case ECommerceEventType.ViewItemList:
                    pushEvent.ecommerce = this.__cleanListEvent(event);
                    break;
                case ECommerceEventType.ViewItem:
                    pushEvent.ecommerce = this.__cleanSingleItemEvent(event);
                    break;
                case ECommerceEventType.ViewPromotion:
                case ECommerceEventType.SelectPromotion:
                default:
                    pushEvent.ecommerce = event;
                    break;
            }
            this.__push(pushEvent);
        }
    }
    __cleanListEvent(event) {
        var _a, _b;
        const cleanEvent = event;
        (_a = cleanEvent.listId) !== null && _a !== void 0 ? _a : (cleanEvent.listId = window.location.pathname
            .replace(/^\/|\/$/g, '')
            .replace('/', '_'));
        (_b = cleanEvent.listName) !== null && _b !== void 0 ? _b : (cleanEvent.listName = cleanEvent.listId
            .replace(/[_-]/g, ' ')
            .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase()));
        return cleanEvent;
    }
    __cleanSingleItemEvent(event) {
        var _a, _b, _c, _d;
        const cleanEvent = event;
        if (!cleanEvent.items || !cleanEvent.items.length) {
            return cleanEvent;
        }
        cleanEvent.items =
            cleanEvent.items.length == 1
                ? cleanEvent.items
                : cleanEvent.items.slice(0, 1);
        (_a = cleanEvent.currency) !== null && _a !== void 0 ? _a : (cleanEvent.currency = cleanEvent.items[0].currency);
        (_b = cleanEvent.value) !== null && _b !== void 0 ? _b : (cleanEvent.value = ((_c = cleanEvent.items[0].price) !== null && _c !== void 0 ? _c : 0.0) -
            ((_d = cleanEvent.items[0].discount) !== null && _d !== void 0 ? _d : 0.0));
        return cleanEvent;
    }
    __cleanMultiItemEvent(event) {
        var _a, _b;
        const cleanEvent = event;
        if (!cleanEvent.items || !cleanEvent.items.length) {
            return cleanEvent;
        }
        (_a = cleanEvent.currency) !== null && _a !== void 0 ? _a : (cleanEvent.currency = cleanEvent.items[0].currency);
        (_b = cleanEvent.value) !== null && _b !== void 0 ? _b : (cleanEvent.value = cleanEvent.items.reduce(function (total, item) {
            var _a, _b;
            return total + (((_a = item.price) !== null && _a !== void 0 ? _a : 0.0) - ((_b = item.discount) !== null && _b !== void 0 ? _b : 0.0));
        }, 0));
        return cleanEvent;
    }
    __push(pushEvent) {
        if (this.__isECommerce(pushEvent)) {
            window.dataLayer.push(emptyECommerce);
        }
        window.dataLayer.push(pushEvent);
    }
    __isECommerce(pushEvent) {
        return pushEvent.ecommerce !== undefined;
    }
    __hasItems(event) {
        return event.items && event.items.length > 0;
    }
}
//# sourceMappingURL=gtm.service.js.map